import { render, staticRenderFns } from "./student-info.vue?vue&type=template&id=e4b5a87a&"
import script from "./student-info.vue?vue&type=script&lang=ts&"
export * from "./student-info.vue?vue&type=script&lang=ts&"
import style0 from "./student-info.vue?vue&type=style&index=0&id=e4b5a87a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports